import * as S from './Pagination.styled';

interface IProps {
  length: number;
  rowsPerPage: number;
  page: number;
  setPage: (page: number) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
}

export const Pagination = ({ length, rowsPerPage, page, setPage, setRowsPerPage }: IProps) => {
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <S.TablePagination
      component="div"
      rowsPerPageOptions={[5, 10, 25]}
      count={length}
      rowsPerPage={rowsPerPage}
      labelRowsPerPage="Rows per page:"
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};
